import BackButton from 'v2/components/BackButton';
import Select from 'v2/components/Select';
import Box from 'v2/components/UI/Box';
import Text from 'v2/components/UI/Text';
import useAddFiles from './hooks/useAddFiles';
import InputText from 'v2/components/Inputs/InputText';
import * as SC from './styles';
import Icon from 'v2/components/Icon';
import ButtonBase from 'v2/components/UI/ButtonBase';
import ButtonsTableBottom from 'v2/components/ButtonsTableBottom';

//TODO: REFACTOR IN UPDATE REACT
const AddFiles: React.FC = () => {
  const {
    optionsCategories,
    isMobile,
    formik,
    joinExtensions,
    isLoadingAddFiles,
    isEditing,
    isLoadingPatchFiles,

    handleDownloadDocument,
    handleFileInput,
    handleRemoveFile,
    handleFormikChange,
    handleOnChangeSelect,
    handleGoBack,
  } = useAddFiles();

  const renderFileSelectedOrEmpty = () => {
    if (formik.values.file) {
      return (
        <SC.LabelFile htmlFor="fileInput">
          <Box
            alignItems="center"
            maxWidth={'90%'}
            justifyContent="space-between"
            gap={10}
          >
            <Text color="#005F47" fontWeight={600}>
              Arquivo selecionado: {formik.values.file.name}
            </Text>

            <ButtonBase
              padding={8}
              background={'#f0000010'}
              borderRadius={8}
              onClick={handleRemoveFile}
            >
              <Icon iconName="CloseOutlined" htmlColor="#f00" />
            </ButtonBase>
          </Box>
        </SC.LabelFile>
      );
    }

    return (
      <SC.LabelFile htmlFor="fileInput">
        Clique aqui para adicionar arquivos: {joinExtensions}
      </SC.LabelFile>
    );
  };

  const renderDownloadFileOrInputFile = () => {
    if (isEditing) {
      return (
        <Box width={'100%'} alignItems="center">
          <ButtonBase
            alignItems="center"
            justifyContent="center"
            gap={10}
            background={'#b7ffbd80'}
            borderRadius={8}
            padding={10}
            width={'100%'}
            onClick={handleDownloadDocument}
          >
            <Icon iconName="CloudDownloadOutlined" htmlColor="#005F47" />
            <Text fontSize={16} color="#005F47" fontWeight={700}>
              Baixar
            </Text>
          </ButtonBase>
        </Box>
      );
    }
    return (
      <Box flexDirection="column" gap={5} width={'100%'}>
        <Box
          width="100%"
          height="120px"
          border={`2px dashed ${formik.errors.file ? '#f00' : '#005F47'}`}
          background={formik.errors.file ? '#f0000010' : '#005F4710'}
          borderRadius={16}
          justifyContent="center"
          alignItems="center"
          transition="background-color 0.3s ease"
        >
          <SC.InputFile
            accept=".pdf,.doc,.docx,.xlsx"
            id="fileInput"
            type="file"
            multiple={false}
            onChange={handleFileInput}
          />
          {renderFileSelectedOrEmpty()}
        </Box>

        {formik.errors.file && (
          <Text color="#f00" fontSize={16} fontWeight={500}>
            {formik.errors.file}
          </Text>
        )}
      </Box>
    );
  };

  return (
    <Box flexDirection="column" gap={30} padding={10}>
      <BackButton title="Voltar" />
      <Box flexDirection="column" gap={15}>
        <Text fontSize={22} fontWeight={700} color="#005F47">
          Adicionar Arquivos
        </Text>

        <Text fontSize={16} fontWeight={500} color="#005F47">
          Preencha as informações abaixo para adicionar um novo arquivo:
        </Text>

        <Box
          background="#fff"
          borderRadius={12}
          padding={10}
          width="100%"
          gap={15}
          flexDirection="column"
        >
          <Select
            options={optionsCategories}
            labelId="select-category"
            selectId="select-category"
            backgroundColor="#005F4710"
            value={formik.values.category}
            name="category"
            errorMessage={formik.errors.category}
            onChange={handleOnChangeSelect}
          />

          <Box flexDirection={isMobile ? 'column' : 'row'} gap={15}>
            <InputText
              label="Título do Arquivo"
              placeholder="Digite o título do arquivo"
              onChange={handleFormikChange}
              value={formik.values.title}
              errorMessage={formik.errors.title}
              name="title"
              width={isMobile ? '100%' : '49%'}
            />

            <InputText
              label="Descrição do Arquivo"
              placeholder="Digite a descrição do arquivo"
              onChange={handleFormikChange}
              value={formik.values.description}
              errorMessage={formik.errors.description}
              name="description"
              width={isMobile ? '100%' : '49%'}
            />
          </Box>

          {renderDownloadFileOrInputFile()}
        </Box>
      </Box>

      <ButtonsTableBottom
        isLoading={isLoadingAddFiles || isLoadingPatchFiles}
        isDisabled={!formik.isValid || isLoadingAddFiles || isLoadingPatchFiles}
        handleClickButtonCta={formik.handleSubmit}
        handleClickButtonCancel={handleGoBack}
      />
    </Box>
  );
};

export default AddFiles;
